import React from 'react'
import { connect } from '@cerebral/react'
import { state } from 'cerebral/tags'
import { t } from '@billes/translator-client'

export default connect(
  {
    selectedFilesCount: state`media.selectedFiles.*`,
    files: state`media.files.*`
  },
  ({ files, selectedFilesCount }) => {
    if (files.length === 0) return null
    return (
      <div
        style={{
          color: 'rgba(0, 0, 0, 0.50)',
          margin: '1px 7px 0 0'
        }}
      >
        {t('bms.media.fileCount', {
          selected: selectedFilesCount.length,
          total: files.length
        })}
      </div>
    )
  }
)



// WEBPACK FOOTER //
// ./src/components/Media/Strip/fileCounter.js